import axios from 'axios'
import * as accessTokenInfo from "../../accessToken";

export const masterLogin = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/appAdmin/masterLogin.php', payload)
    .then(res => {
        
        console.log(JSON.stringify(res.data))
        if(res.data.status) {
            //window.open('http://localhost:8080/master-login-request?masterLoginRequest='+res.data.access_token)
            window.open('https://cloud.easytailorapp.com/master-login-request?masterLoginRequest='+res.data.access_token)
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-2'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const login = ({commit, dispatch}, payload) => {

    commit('toggleLoadingState', true)
            
    axios.post('/appAdmin/login/index.php', payload)
    .then(res => {
        if(res.data.status) {
            localStorage.setItem('accessToken', res.data.access_token)
            dispatch('checkAccessToken', { navigate: true })
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error', displayHTML: true});
        }
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const checkAccessToken = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.get('/appAdmin/login/checkAccessToken.php', accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        dispatch('loadCountryList')
        
        if(res.data.status) {
            let response = res.data
            response.navigate = payload.navigate
            commit('setAccessToken', response)             
        } else {
            if(res.data.message !== undefined && res.data.message.length>0) {
                commit('displayMessageAlert', {message: res.data.message, type: 'Error'})            
            }
            dispatch('logout')
        }

    })
    .catch(error => {
        //commit('displayMessageAlert', {message: error, type: 'Error-3'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const changePassword = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/appAdmin/login/changePassword.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {
        
        if(res.data.status) {
            dispatch('logout')               
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error'})
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const fetchWhatsAppLicenseList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/appAdmin/whatsApp/checkLicenseList.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            commit('setWhatsappLicenseList', res.data.response)
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error'})
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const fetchPaymentList = ({commit}) => {
    
    commit('toggleLoadingState', true)
    axios.get('/appAdmin/tenant/paymentList.php', accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            commit('setPaymentList', res.data.response)
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error'})
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const fetchSubscriptionList = ({commit}) => {
    
    commit('toggleLoadingState', true)
    axios.get('/appAdmin/tenant/subscriptionList.php', accessTokenInfo.accessTokenInfo())
    .then(res => {

        if(res.data.status) {
            commit('setSubscriptionList', res.data.response)
        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error'})
        }

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const fetchCouponList = ({commit}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/appAdmin/coupons/index.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        commit('setCouponList', res.data.response.response)
        
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const markPaymentWebhookAsRead = ({commit, dispatch}, payload) => {
    
    commit('toggleLoadingState', true)
    axios.post('/appAdmin/tenant/markPaymentWebhookAsRead.php', payload, accessTokenInfo.accessTokenInfo())
    .then(res => {

        dispatch('fetchSubscriptionList')
        dispatch('fetchPaymentList')

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

/*** MASTER DATA ***/

export const loadCountryList = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/masterData/loadCountryList.php', payload)
    .then(res => {
        
        commit('setCountryList', res.data.country_list)              

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const loadProvinceList = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/masterData/loadProvinceList.php', payload)
    .then(res => {
        
        commit('setProvinceList', res.data.province_list)              

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

export const loadCityList = ({commit}, payload) => {

    commit('toggleLoadingState', true)
    axios.post('/masterData/loadCityList.php', payload)
    .then(res => {
        
        commit('setCityList', res.data.city_list)              

    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}

/*** END MASTER DATA ***/

export const logout = ({commit}) => {
    
    commit('toggleLoadingState', true)

    axios.get('/appAdmin/login/logout.php', accessTokenInfo.accessTokenInfo())
    .then(res => { 
        if(res.data.status) {
            commit('clearAuthData')

        } else {
            commit('displayMessageAlert', {message: res.data.message, type: 'Error'})
        }
    })
    .catch(error => {
        commit('displayMessageAlert', {message: error, type: 'Error-access-token'})
    })
    .finally( () => {
        commit('toggleLoadingState', false)
    })
    
}


// WEBPACK FOOTER //
// ./src/store/modules/master/actions.js